@if (!engine.initInProgress) {
  @if (!engine.initError) {
    <crm-single-select
      #singleSelectComponent
      [options]="engine.values"
      [selectedItem]="appliedValue"
      (selectedItemChange)="onSelect($event)"
      [label]="labelInput ? labelInputText : ''"
      [placeholder]="placeholder"
      [filtersUiVersion]="filtersUiVersion"
      [disabled]="!!disabled"
      [class]="class || ''"
      [styleClass]="styleClass || ''"
      [itemStyleClass]="itemStyleClass || ''"
      [isError]="isError || engine.selectionError"
      [emptyMessage]="engine.listError || 'Список пуст'"
      [emptyFilterMessage]="engine.listError && !engine.values.length ? engine.listError : 'Нет результатов'"
      [loading]="engine.loading || engine.selectionLoading"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      (onShow)="onShowPanel()"
      (onHide)="onHidePanel()"
      (onFilter)="search($event.filter)"
      [appendTo]="appendTo"
      [showClear]="showClear"
      [sort]="engine.sort || 'name'"
      [optionValue]="engine.optionValue || 'id'"
      [filterBy]="engine.filterBy || 'name'">
      <ng-template
        #selectedItemTemplate
        let-maybeItem="item">
        @if (maybeItem | standardDropdownItem: engine.transformedItems : engine.optionValue; as item) {
          {{ item?.name }}
        }
      </ng-template>

      <ng-template
        #itemTemplate
        let-maybeItem="item">
        @if (maybeItem | standardDropdownItem: engine.transformedItems : engine.optionValue; as item) {
          <crm-standard-dropdown-item
            [item]="item"
            [filterValue]="filterValue"
            [singleLine]="singleLine ?? virtualScroll"></crm-standard-dropdown-item>
        }
      </ng-template>

      <ng-template #footerTemplate>
        @if (engine.paginationLoading) {
          <crm-spinner
            top=""
            text=""
            [height]="35"
            [width]="35"
            bottom=""></crm-spinner>
        } @else if (engine.listError && engine.values.length) {
          <div class="px-3 py-2 text-red-500">{{ engine.listError }}</div>
        }
      </ng-template>
    </crm-single-select>
  } @else {
    <div [class]="styleClass">{{ engine.initError }}</div>
  }
} @else {
  <p-skeleton height="28px" [styleClass]="styleClass"></p-skeleton>
}
